module.exports = __webpack_public_path__ + "static/media/craft-08.5ab8e2bc.svg";